export default __webpack_public_path__ + "static/media/syncpay.32526ec0.png";